import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/providers/auth-provider";
import { listItemCards } from "@/services/inventory/list-item-cards";
import { queryKeys } from "./query-keys";

export const useItemCardInventory = () => {
  const { state } = useAuth();

  return useQuery({
    queryKey: queryKeys.inventoryItemCards,
    queryFn: async () => {
      const response = await listItemCards();
      if (!response.ok) throw new Error(response.message);
      return response.data.player_item_cards;
    },
    enabled: state.status === "authenticated",
  });
};
